export abstract class AbstractFormatter {
  /**
   * Deixa apenas números e letras.
   */
  protected clearValue(value: string) {
    const clearedValue = String(value).match(/[0-9]/g) || [];

    return clearedValue.join('');
  }

  /**
   * Formata o valor passado.
   */
  protected formatValue(value = '', mask = '') {
    value = value.toString();

    const output = [];
    let count = 0;

    for (let i = 0; i < mask.length; i++) {
      if (value[i + count] != undefined) {
        if (mask[i] == '9') {
          if (new RegExp(/[0-9]/).test(value[i + count])) {
            output.push(value[i + count]);
          }
        } else if (mask[i] == 'A') {
          if (new RegExp(/[a-zA-Z]/).test(value[i + count])) {
            output.push(value[i + count]);
          }
        } else if (mask[i] == undefined) {
          break;
        } else {
          output.push(mask[i]);
          count--;
        }
      }
    }

    return output.join('');
  }
}
